import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {observer} from 'mobx-react';
import {LauncherSearchBoxComponent} from '../app-search/search-box/launcher-search-box.component';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {LauncherAppBarButtonsComponent} from './launcher-app-bar-buttons.component';
import {getDrawerWidth} from "../../utils/get-drawer-width";

const styles = (theme: Theme) => createStyles ({
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${getDrawerWidth()}px)`,
            marginLeft: getDrawerWidth(),
        }
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    grow: {
        flexGrow: 1,
    }

});

export interface LauncherAppBarComponentProps extends WithStyles<typeof styles>{

}

export const LauncherAppBarComponent = withStyles(styles)(
    observer(
        class extends LauncherComponentBase<LauncherAppBarComponentProps> {

            private _handleToggleDrawer = () => {
                this.services.drawer.toggleDrawer();
            };

            private _renderMenuButton() {
                if(!this.services.deviceTypeDetection.isMobile) {
                    return null;
                }
                return (
                    <IconButton edge="start" className={this.props.classes.menuButton} color="inherit" aria-label="menu" onClick={this._handleToggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                );
            }

            render() {
                return (
                    <AppBar position="fixed" className={this.props.classes.appBar}>
                        <Toolbar>
                            {this._renderMenuButton()}
                            <LauncherSearchBoxComponent/>
                            <span className={this.props.classes.grow}></span>
                            <LauncherAppBarButtonsComponent/>
                        </Toolbar>
                    </AppBar>
                );
            }
        }
    )
);

